import { defineMessages } from 'react-intl'

export default defineMessages({
  audiobook: {
    id: 'data.products.audiobook',
    defaultMessage: 'Audiobook',
  },
  'audio-guide': {
    id: 'data.products.audio-guide',
    defaultMessage: 'Audio guide',
  },
  elearning: {
    id: 'data.products.elearning',
    defaultMessage: 'eLearning',
  },
  navigation: {
    id: 'data.products.navigation',
    defaultMessage: 'Navigation',
  },
  'video-presentation-product-video': {
    id: 'data.products.video-presentation-product-video',
    defaultMessage: 'Video Presentation',
  },
  technology: {
    id: 'data.products.technology',
    defaultMessage: 'Technology',
  },
  'tv-narrator-documentary': {
    id: 'data.products.tv-narrator-documentary',
    defaultMessage: 'TV Narrator / Documentary',
  },
  commercial: {
    id: 'data.products.commercial',
    defaultMessage: 'Commercial',
  },
  'television-series': {
    id: 'data.products.television-series',
    defaultMessage: 'Television Series',
  },
  movie: {
    id: 'data.products.movie',
    defaultMessage: 'Movie',
  },
  'animation-movie': {
    id: 'data.products.animation-movie',
    defaultMessage: 'Animation Movie',
  },
  'animation-series': {
    id: 'data.products.animation-series',
    defaultMessage: 'Animation Series',
  },
  'audio-description-ad': {
    id: 'data.products.audio-description-ad',
    defaultMessage: 'Audio Description (AD)',
  },
  'automated-dialogue-replacement-adr': {
    id: 'data.products.automated-dialogue-replacement-adr',
    defaultMessage: 'Automated Dialogue Replacement (ADR)',
  },
  gaming: {
    id: 'data.products.gaming',
    defaultMessage: 'Gaming',
  },
  subtitles: {
    id: 'data.products.subtitles',
    defaultMessage: 'Subtitles',
  },
  'event-presentation-internal': {
    id: 'data.products.event-presentation-internal',
    defaultMessage: 'Event Presentation / Internal',
  },
  ivr: {
    id: 'data.products.ivr',
    defaultMessage: 'Phone Prompts',
  },
  podcast: {
    id: 'data.products.podcast',
    defaultMessage: 'Podcast',
  },
  character: {
    id: 'data.products.character',
    defaultMessage: 'Character',
  },
})
